import axios from "axios";
import CONFIG from "../config";
import { attachAuthInterceptor } from "./authInterceptor";

const lookbookApi = axios.create({
  baseURL: CONFIG.CUSTOMER_SERVICE_URL,
});

// Use the shared interceptor so an expired access token is silently refreshed
// and retried — instead of hard-logging-out on the first 401 (which kicked
// active users to /login the moment their 1h token lapsed).
attachAuthInterceptor(lookbookApi);

export const getLookbookSeasons = async () => {
  const response = await lookbookApi.get("/analytics/lookbook/seasons");
  return response.data;
};

export const getLookbookSeasonDefaults = async (season) => {
  const response = await lookbookApi.get("/analytics/lookbook/season-defaults", {
    params: { season },
  });
  return response.data;
};

export const createLookbookReportJob = async ({ season, date_from, date_to }) => {
  const response = await lookbookApi.post("/analytics/lookbook/jobs", {
    season,
    date_from,
    date_to,
  });
  return response.data;
};

export const getLookbookJobStatus = async (jobId) => {
  const response = await lookbookApi.get(`/analytics/lookbook/jobs/${jobId}`);
  return response.data;
};

export const getLookbookJobResult = async (jobId) => {
  const response = await lookbookApi.get(`/analytics/lookbook/jobs/${jobId}/result`);
  return response.data;
};

export const downloadLookbookExcel = async (jobId) => {
  const response = await lookbookApi.get(`/analytics/lookbook/jobs/${jobId}/export`, {
    responseType: "blob",
  });
  return response;
};

export const createFullComparisonJob = async ({ as_of_date, season_group }) => {
  const response = await lookbookApi.post("/analytics/lookbook/comparison/full/jobs", {
    as_of_date,
    season_group,
  });
  return response.data;
};

export const getFullComparisonJobStatus = async (jobId) => {
  const response = await lookbookApi.get(`/analytics/lookbook/comparison/full/jobs/${jobId}`);
  return response.data;
};

export const getFullComparisonJobResult = async (jobId) => {
  const response = await lookbookApi.get(
    `/analytics/lookbook/comparison/full/jobs/${jobId}/result`
  );
  return response.data;
};

export const downloadFullComparisonExcel = async (jobId) => {
  const response = await lookbookApi.get(
    `/analytics/lookbook/comparison/full/jobs/${jobId}/export`,
    {
      responseType: "blob",
    }
  );
  return response;
};
